export enum AUTH_CHANNEL_STATUS {
  NOT_CONNECTED = 'NOT_CONNECTED',
  CONNECTED = 'CONNECTED',
  TIMEOUT = 'TIMEOUT',
  ERROR = 'ERROR',
}
